import AcademyInfoFooter from './AcademyInfoFooter';
import CertificateImage from './CertificateImage';
import CurriculumInfo from './CurriculumInfo';
import FooterCTA from './FooterCTA';
import ColorCirclesHeader from '../../../components/ColorCirclesHeader';
import AchievementNotFound from './AchievementNotFound';
import AchievementUserProfile from './AchievementUserProfile';
import CertificateHeader from './CertificateHeader';
import { getBrochureRoot, usePublicAchievement } from '../achievementQueries';
import { NavMarker } from 'react-rhumb';
import { useEffect } from 'react';
import PrerenderGlobals from './PrerenderGlobals';
import { View } from 'foundations-components/components/View';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = ({
  children
}) => {
  return /*#__PURE__*/_jsx(View, {
    marginInline: "auto",
    maxInlineSize: '1140px',
    paddingInline: "500",
    children: children
  });
};
export const SingleCertAchievement = ({
  inModal,
  trackEvent,
  publicId,
  language
}) => {
  const {
    publicAchievementLoading,
    publicAchievementError
  } = usePublicAchievement(publicId);
  const brochureRoot = getBrochureRoot(language);
  useEffect(() => trackEvent({
    action: 'view-achievement'
  }), [trackEvent]);
  if (publicAchievementLoading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      marginBlock: "1200"
    });
  }
  if (publicAchievementError) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "ACHIEVEMENT_MISSING",
      children: /*#__PURE__*/_jsx(AchievementNotFound, {
        brochureRoot: brochureRoot,
        language: language
      })
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "achievement-public",
    children: [/*#__PURE__*/_jsx(PrerenderGlobals, {
      language: language,
      publicId: publicId
    }), /*#__PURE__*/_jsxs(NavMarker, {
      name: "ACHIEVEMENT_LOADED",
      children: [/*#__PURE__*/_jsx(View, {
        backgroundColor: "fill-surface-default",
        children: /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsx(CertificateHeader, {
            inModal: inModal,
            language: language,
            trackEvent: trackEvent
          })
        })
      }), /*#__PURE__*/_jsx(ColorCirclesHeader, {
        children: /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsx(AchievementUserProfile, {
            publicId: publicId
          })
        })
      }), /*#__PURE__*/_jsx(View, {
        backgroundColor: "fill-surface-default",
        children: /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsxs(Flex, {
            flexDirection: "row",
            flexWrap: "wrap",
            children: [/*#__PURE__*/_jsx(View, {
              flex: "1",
              minInlineSize: "300px",
              children: /*#__PURE__*/_jsx(CertificateImage, {
                inModal: inModal,
                language: language,
                publicId: publicId,
                trackEvent: trackEvent
              })
            }), /*#__PURE__*/_jsx(View, {
              flex: "1",
              minInlineSize: "300px",
              children: /*#__PURE__*/_jsx(CurriculumInfo, {
                language: language,
                publicId: publicId
              })
            })]
          })
        })
      }), /*#__PURE__*/_jsxs(View, {
        backgroundColor: "fill-accent-neutral-default",
        children: [/*#__PURE__*/_jsx(AcademyInfoFooter, {
          inModal: inModal
        }), !inModal && /*#__PURE__*/_jsx(FooterCTA, {
          language: language,
          publicId: publicId,
          trackEvent: trackEvent
        })]
      })]
    })]
  });
};